/* eslint-disable no-unused-expressions */
import React, { Component } from 'react'
import { FaChevronDown } from 'react-icons/fa'
import DropdownInput from './sorting-input'
import { styled, Checkbox, Button, context, withContext } from '@tools/wr-catalog-base'

const OptionWrapper = styled.div`
  padding: 15px;
`

const DropdownWrapper = styled.div`
  z-index: 9;
  .sorting__control {
    visibility: hidden;
    position: absolute;
  }

  div.dropdown-input {
    margin-top: 0;
  }

  .sorting__menu {
    width: 350px;
    right: 0;
  }
`

const DefaultTriggerButton = (props) => {
  const { onClick } = props

  return (
    <Button
      primary
      onClick={(...args) => {
        onClick(...args)
      }}
    >
      Sort By <FaChevronDown />
    </Button>
  )
}

class SortingButton extends Component {
  isFocused = false

  constructor(props) {
    super(props)
    this.state = {
      sortingValue: context.state.activeSorting || context.constants.sortingOptions[0] || null,
    }
  }

  state = {
    sortingValue: null,
  }

  Option = (props) => {
    props.theme.colors.primary = 'transparent'

    return (
      <OptionWrapper key={props.data.id} isSelected={props.isSelected} onClick={() => props.selectOption(props.data)}>
        <Checkbox type="checkbox" checked={props.isSelected} onChange={() => null} /> <label>{props.label}</label>
      </OptionWrapper>
    )
  }

  triggerSelect = () => {
    if (this.isFocused) {
      console.log('focused')
      document.querySelector('.sorting__input input')?.blur()
    } else {
      console.log('in else')
      document.querySelector('.sorting__control')?.click()
    }
  }

  handleSortingChange = (sortingOptions) => {
    const { context } = this.props

    if (sortingOptions && sortingOptions.length) {
      context.actions.updateSorting(sortingOptions[(sortingOptions?.length || 1) - 1])
      this.setState({
        sortingValue: sortingOptions[sortingOptions.length - 1],
      })
    }
  }

  onMenuOpen = () => {
    this.isFocused = true
  }

  onMenuClose = () => {
    setTimeout(() => {
      this.isFocused = false
    }, 200)
  }

  render() {
    const options = context.constants.sortingOptions
    const TriggerButton =
      context.theme.components.productList.toolbar.sortingDropdown.buttonComponent || DefaultTriggerButton

    return (
      <>
        <TriggerButton onClick={this.triggerSelect} type="button" {...this.props.buttonProps} />
        <DropdownWrapper>
          <DropdownInput
            value={this.state.sortingValue || undefined}
            onChange={this.handleSortingChange}
            onMenuClose={this.onMenuClose}
            onMenuOpen={this.onMenuOpen}
            options={options}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            className="sorting"
            classNamePrefix="sorting"
            components={{ Option: this.Option }}
            isMulti
            large
            fullWidth
          />
        </DropdownWrapper>
      </>
    )
  }
}

export default withContext(SortingButton)
